<div *appIsDesktop class="b2b-user-cart-container">
  @if (editMode) {
    <div>
      <app-b2b-cart-summary-notifications [cartItems]="cartItems.slice(1)">
      </app-b2b-cart-summary-notifications>
      <div class="search-container-desktop">
        <app-grid-product-search
          [disabled]="loading"
          [countryCodeId]="countryCodeId"
          (toolSelected)="onProductSelected($event)"
          [verticalLabel]="false">
        </app-grid-product-search>
        <typography variant="mat-caption-1" weight="regular">
          {{ cartItems.length - 1 }} {{ appStrings.b2bCart_itemsInCart }}
        </typography>
      </div>
    </div>
  }

  @if ((!loading && cartItems.length > 0) || editMode) {
    <ds-table [id]="'cartTable-' + userIndex" mat-table [dataSource]="cartItems" [displayedColumns]="displayedColumns">
      <ng-container matColumnDef="itemNumber">
        <th mat-header-cell *matHeaderCellDef [id]="'itemNumberHeader-' + userIndex">{{ appStrings.b2bCart_itemNumber }}</th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'itemNumber-' + userIndex + '-' + index">
          @if (editMode) {
            <ds-textfield
              class="no-subscript"
              [id]="'itemNumberInput-' + userIndex + '-' + index"
              [control]="getControl(index, 'itemNumber')"
              (onBlur)="index > 0 ? updateCartItemNumber(item, index) : null">
            </ds-textfield>
          }
          @if (!editMode) {
            <span>{{ item.ModelNumber }}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef [id]="'quantityHeader-' + userIndex">{{ appStrings.b2bCart_quantity }}</th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'quantity-' + userIndex + '-' + index">
          @if (editMode) {
            <ds-textfield
              class="no-subscript quantity-input"
              [id]="'quantityInput-' + userIndex + '-' + index"
              [control]="getControl(index, 'quantity')"
              [maxLength]="5"
              (onBlur)="index > 0 ? updateCartItemQuantity(item, index) : null">
            </ds-textfield>
          }
          @if (!editMode) {
            <span>{{ item.Quantity }}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef [id]="'priceHeader-' + userIndex">{{ appStrings.b2bCart_price }}</th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'price-' + userIndex + '-' + index">
          {{ cartCurrencySymbol }}{{ item.NetPrice }}
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef [id]="'descriptionHeader-' + userIndex">{{ appStrings.b2bCart_description }}</th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'description-' + userIndex + '-' + index">
          {{ item.Name ?? '-' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="unitPrice">
        <th mat-header-cell *matHeaderCellDef [id]="'unitPriceHeader-' + userIndex">{{ appStrings.b2bCart_unitPrice }}</th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'unitPrice-' + userIndex + '-' + index">
          @if (editMode) {
            <span>{{ cartCurrencySymbol }}{{ item.NetPrice ?? '-'}}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="totalPrice">
        <th mat-header-cell *matHeaderCellDef [id]="'totalPriceHeader-' + userIndex">{{ appStrings.b2bCart_totalPrice }}</th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'totalPrice-' + userIndex + '-' + index">
          @if (editMode) {
            <span>{{ cartCurrencySymbol }}{{ getTotalPrice(item) | number:'1.2-2' }}</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="notifications">
        <th mat-header-cell *matHeaderCellDef [id]="'notificationsHeader-' + userIndex"></th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'notifications-' + userIndex + '-' + index">
          <app-b2b-cart-notifications
            [item]="item"
            [itemIndex]="index"
            [userIndex]="userIndex"
            [isDisabled]="loading"
            (notificationAction)="handleNotificationAction($event)">
          </app-b2b-cart-notifications>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [id]="'actionsHeader-' + userIndex"></th>
        <td mat-cell *matCellDef="let item; let index = dataIndex" [id]="'actions-' + userIndex + '-' + index">
          @if (index === 0 && editMode) {
            <ds-button
              [id]="'addBtn-' + userIndex"
              [label]="appStrings.button_add"
              type="secondary"
              variant="label-only"
              size="medium"
              (onClick)="addItem()">
            </ds-button>
          }
          @if (index > 0 && editMode) {
            <ds-button
              [id]="'deleteBtn-' + userIndex + '-' + index"
              [label]="appStrings.button_delete"
              type="tertiary"
              variant="label-icon"
              icon="delete"
              iconPosition="left"
              iconStyle="material-icons-outlined"
              size="medium"
              (onClick)="deleteItem(item)">
            </ds-button>
          }
        </td>
      </ng-container>
    </ds-table>
  }

  <ng-container *ngTemplateOutlet="loadingState"></ng-container>
  <ng-container *ngTemplateOutlet="loadingEditState"></ng-container>
  <ng-container *ngTemplateOutlet="emptyState"></ng-container>
</div>

<div *appIsMobile class="mobile">
  @if (editMode) {
    <div>
      <app-b2b-cart-summary-notifications [cartItems]="cartItems.slice(1)">
      </app-b2b-cart-summary-notifications>
      <div class="search-container">
        <app-grid-product-search
          [disabled]="loading"
          [countryCodeId]="countryCodeId"
          (toolSelected)="onProductSelected($event)">
        </app-grid-product-search>
      </div>
    </div>
  }
  @for (item of (editMode ? cartItems.slice(1) : cartItems); track item; let i = $index) {
    <mat-expansion-panel class="mobile-card" [class.grey]="!editMode"
      [id]="'cartItem-' + userIndex + '-' + i" [expanded]="true">
      <div class="mobile-item-content">
        <!-- Item Number and Quantity -->
        <div class="row">
          <div class="col col-half-width">
            <typography variant="caption-2" weight="regular" class="label"
              [id]="'itemNumberLabel-' + userIndex + '-' + i">
              {{ appStrings.b2bCart_itemNumber }}
            </typography>
            <typography variant="caption-1" weight="bold"
              [id]="'itemNumberValue-' + userIndex + '-' + i">
              {{ item.ModelNumber }}
            </typography>
          </div>
          <div class="row">
            <div class="col col-half-width">
              <typography variant="caption-2" weight="regular" class="label"
                [id]="'quantityLabel-' + userIndex + '-' + i">
                {{ appStrings.b2bCart_quantity }}
              </typography>
              <typography variant="caption-1" weight="bold"
                [id]="'quantityValue-' + userIndex + '-' + i">
                {{ item.Quantity }}
              </typography>
            </div>
            @if (editMode) {
              <div class="item-actions-mobile">
                <ds-button
                  [id]="'deleteBtn-' + userIndex + '-' + i"
                  type="secondary"
                  variant="icon-only"
                  icon="delete"
                  iconStyle="material-icons-outlined"
                  size="medium"
                  (onClick)="deleteItem(item)">
                </ds-button>
                <ds-button
                  [id]="'editBtn-' + userIndex + '-' + i"
                  type="secondary"
                  variant="icon-only"
                  icon="edit"
                  iconStyle="material-icons-outlined"
                  size="medium"
                  (onClick)="openItemDialog(false, i + 1)">
                </ds-button>
              </div>
            }
          </div>
        </div>
        <!-- Description -->
        <div class="row">
          <div class="col">
            <typography variant="caption-2" weight="regular" class="label"
              [id]="'descriptionLabel-' + userIndex + '-' + i">
              {{ appStrings.b2bCart_description }}
            </typography>
            <typography variant="caption-1" weight="bold"
              [id]="'descriptionValue-' + userIndex + '-' + i">
              {{ item.Name ?? '-' }}
            </typography>
          </div>
        </div>
        <!-- Unit Price and Total Price -->
        <div class="row">
          <div class="col col-half-width">
            <typography variant="caption-2" weight="regular" class="label"
              [id]="'unitPriceLabel-' + userIndex + '-' + i">
              {{ appStrings.b2bCart_unitPrice }}
            </typography>
            <typography variant="caption-1" weight="bold"
              [id]="'unitPriceValue-' + userIndex + '-' + i">
              {{ cartCurrencySymbol }}{{ item.NetPrice ?? '-' }}
            </typography>
          </div>
          <div class="col col-half-width">
            <typography variant="caption-2" weight="regular" class="label"
              [id]="'totalPriceLabel-' + userIndex + '-' + i">
              {{ appStrings.b2bCart_totalPrice }}
            </typography>
            <typography variant="caption-1" weight="bold"
              [id]="'totalPriceValue-' + userIndex + '-' + i">
              {{ cartCurrencySymbol }}{{ getTotalPrice(item) | number:'1.2-2' }}
            </typography>
          </div>
        </div>
        <!-- Notifications -->
        <div class="mobile-notifications">
          <app-b2b-cart-notifications
            [item]="item"
            [itemIndex]="i"
            [userIndex]="userIndex"
            [isDisabled]="loading"
            (notificationAction)="handleNotificationAction($event)">
          </app-b2b-cart-notifications>
        </div>
      </div>
    </mat-expansion-panel>
  }

  <ng-container *ngTemplateOutlet="loadingState"></ng-container>
  <ng-container *ngTemplateOutlet="loadingEditState"></ng-container>
  <ng-container *ngTemplateOutlet="emptyState"></ng-container>
  <ng-container *ngTemplateOutlet="emptyStateMobileEdit"></ng-container>
</div>

<!-- TEMPLATES -->
<ng-template #loadingState>
  @if (loading && !editMode) {
    <div class="cart-state-message">
      <ds-progress-spinner [id]="'cartLoader-' + userIndex"></ds-progress-spinner>
    </div>
  }
</ng-template>

<ng-template #loadingEditState>
  @if (loading && editMode) {
    <div class="cart-state-message overlay full">
      <ds-progress-spinner [id]="'cartLoader-' + userIndex"></ds-progress-spinner>
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
    </div>
  }
</ng-template>

<ng-template #emptyState>
  @if (hasLoaded && cartItems.length === 0 && !editMode) {
    <div [id]="'emptyCart-' + userIndex" class="cart-state-message">
      <typography variant="mat-body-2" weight="regular">{{ appStrings.noEntriesFound }}</typography>
    </div>
  }
</ng-template>

<ng-template #emptyStateMobileEdit>
  <div class="empty-state-mobile-container">
    @if (hasLoaded && cartItems.length === 1 && editMode) {
      <ds-paper
        [id]="'emptyCart-' + userIndex" insidePaddingTop="top-spacing_XL" insidePaddingBottom="bottom-spacing_XL"
        insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
        <div class="empty-state-mobile">
          <ds-icon icon="production_quantity_limits" iconStyle="material-icons-outlined">
          </ds-icon>
          <typography variant="body-2" weight="regular">
            {{ appStrings.b2bCart_emptyCartMessage }}
          </typography>
        </div>
      </ds-paper>
    }
  </div>
</ng-template>
